<template>
  <div class="scale-with-screen">
    <div class="book-contributors">
      <div class="bpg-title">
        <span>{{ contributorTitle }}</span>
      </div>
      <div>
      <div
        v-for="(item, i) of contributors"
        :key="'author-summary_' + i"
        class="book-contributors-authors"
      >
        <div v-if="item.fullName" class="book-contributors-author-name">
          {{ item.fullName }}
        </div>
        <div v-if="item.biography" class="book-contributors-text" v-html="item.biography" />
        <div v-if="!item.biography || item.biography.length === 0" class="book-contributors-text">
          Biography not available for this author.
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'BookContributors',
  props: {
    contributors: {
      type: Array,
      default: () => ([])
    }

  },
  data () {
    return {
      contributorTitle: this.contributors.length > 1 ? 'About The Authors' : 'About The Author'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';

  .book-contributors {
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: left;
    margin-top: 3em;
    background-color: $even-lighter-green;
    padding:3em;
    padding-top:0;
    .bpg-title {
      text-align:left;
    }
    .bpg-title:after {
      width:100%;
    }
    .book-contributors-authors {
      text-align: left;
      .book-contributors-author-name {
        font-size: $font-large;
        padding-top:1em;
      }
      .book-contributors-text {
        font-size: $font-medium;
        padding-top:1em;
      }
    }
  }
  @media only screen and (max-width: 750px) {
    .book-contributors {
      font-size: 220%;
    }
  }
</style>
